import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { I18nService } from 'src/app/services/i18n.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DialogContentInscription } from '../inscription-dialog/dialog-content-inscription';
import { DialogContentForgotPassword } from '../forgot-password-dialog/dialog-content-forgot-password';

@Component({
    selector: 'dialog-content-login',
    templateUrl: 'dialog-content-login.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogContentLogin implements OnInit {
  loginForm!: FormGroup;
  loading = false;
  submitted = false;
  returnUrl!: string;
  error = '';
  user!: User | null;
  successLogin: boolean = false;
  errorFetch: boolean = false;
  deviceInfo!: any;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  acceptNewsLetter: boolean = false;
  email!: string;
  cookiesNewsletter!: string | null;

  private i18n = inject(I18nService);

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private deviceService: DeviceDetectorService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogContentLogin> // Inject MatDialogRef pour fermer le dialogue
  ) {
    this.epicFunction();
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    // Récupérer l'URL de retour des paramètres ou définir une valeur par défaut
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // Accéder facilement aux champs du formulaire
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;

    this.authService.login(this.f.username.value, this.f.password.value).subscribe((responseToken) => {
      if (responseToken && responseToken.access_token) {
        this.setConsent(1);
        this.successLogin = true;
        this.loading = false;
        this.dialogRef.close();
      } else {
        this.loading = false;
        this.errorFetch = true;
        this.error = this.i18n.t('common.errorOccurred')
      }
    }, (err) => {
      this.loading = false;
      this.errorFetch = true;
      this.error = (err && err !== 'Unauthorized') ? err : this.i18n.t('auth.loginFailed');
    });
  }

  public setConsent(value: any): void {
    localStorage.setItem('cookies_login', value);
  }

  public openDialogForgotPassword(): void {
    this.dialog.open(DialogContentForgotPassword, {
      width: '450px',
    });
  }

  public openDialogInscription(): void {
    const dialogRef = this.dialog.open(DialogContentInscription, {
      width: '550px',
      data: { acceptNewsLetter: this.acceptNewsLetter, email: this.email },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.acceptNewsLetter = result?.acceptNewsLetter;
      this.email = result?.email;
      if (result === false) {
        this.setConsent("0");
        this.cookiesNewsletter = "0";
      } else {
        this.setConsent("1");
        this.cookiesNewsletter = "1";
      }
    });
  }

  private epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }
}
